export default "__VITE_ASSET__5b9b3ad8__"